import React, { Component } from "react";
import Header from "./Header";
import HeaderIntro from "./HeaderIntro";
import Footer from "./Footer";
import NewsLetter from "./NewsLetter";
export class ForeignIncomeTaxFiling extends Component {
  render() {
    return (
      <div>
        <Header />
        <HeaderIntro />
        <section id="contact" style={{ backgroundColor: "#f3f9fd" }}>
          <div className="container">
            <div class="container-fluid" data-aos="fade-up">
              <div class="section-header">
                <h3>Foreign Income Tax Filing</h3>
                <p>
                  {" "}
                  Our solutions and services are not only limited to the
                  citizens of India but also to NRIs seeking help regarding
                  their taxation needs.
                </p>
              </div>
            </div>
          </div>
        </section>
        <NewsLetter/>
        <Footer />
      </div>
    );
  }
}

export default ForeignIncomeTaxFiling;
